import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

const Icon = styled.div`
    position: relative;
    height: 15px;
    width: 15px;
    flex: 0 0 auto;

    &::before,
    &::after {
        content: "";
        position: absolute;
        display: block;
        background-color: currentColor;
    }

    &::before {
        width: 100%;
        height: 2px;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        border: 1px solid transparent;
    }

    &::after {
        display: ${({ open }) => (open ? `none` : `block`)};
        height: 100%;
        width: 2px;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        border: 1px solid transparent;
    }
`;

const PlusIcon = ({ open = false }) => <Icon {...{ open }} />;

PlusIcon.propTypes = {
    open: PropTypes.bool,
};

export default PlusIcon;
